import { DeployPhase } from "./deploy-phase";
import { Variable } from "./variable";

export class ReleaseEnvironment {
  name: string;
  id: number;
  rank: number;
  variables: Variable[] = [];
  deployPhases: DeployPhase[];
  status = 'unchanged';
  childStatus = 'unchanged';

  public constructor (name: string, id: number, rank: number, deployPhases: DeployPhase[]) {
    this.name = name;
    this.id = id;
    this.rank = rank;
    this.deployPhases = deployPhases;
  }
}